// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import categoryApi from '~/apis/category';
import { IBodyUpdate, IQueryParamBase } from '~/utils/interface/common';
import {
  CREATE_CATEGORY,
  DELETE_CATEGORY,
  GET_DETAIL_CATEGORY,
  GET_LIST_CATEGORY,
  UPDATE_CATEGORY,
} from '~/utils/constants/actionType';

export const getListCategory = createAsyncThunk(
  GET_LIST_CATEGORY,
  async (params: IQueryParamBase, { rejectWithValue }) => {
    try {
      const resp = await categoryApi.getListCategory(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createCategory = createAsyncThunk(CREATE_CATEGORY, async (formData: FormData, { rejectWithValue }) => {
  try {
    const resp = await categoryApi.createCategory(formData);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const deleteCategory = createAsyncThunk(DELETE_CATEGORY, async (id: string, { rejectWithValue }) => {
  try {
    const resp = await categoryApi.deleteCategory(id);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateCategory = createAsyncThunk(
  UPDATE_CATEGORY,
  async (params: IBodyUpdate<FormData>, { rejectWithValue }) => {
    try {
      const resp = await categoryApi.updateCategory(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDetailCategory = createAsyncThunk(GET_DETAIL_CATEGORY, async (id: string, { rejectWithValue }) => {
  try {
    const resp = await categoryApi.getDetailCategory(id);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
